import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBIcon,
} from "mdbreact";
import { Button, Pane, Text } from "evergreen-ui";
import axios from "axios";
import MetaTags from "react-meta-tags";
import registernormal1 from "../assets/2025/btn1.png";
import registernormal2 from "../assets/2025/btn2.png";
import registernormal3 from "../assets/2025/btn3.png";
import registernormal4 from "../assets/2025/btn4.png";
import registernormalk1 from "../assets/2025/ksbp1.png";
import registernormalk2 from "../assets/2025/ksbp2.png";
import registernurse from "../assets/2025/btnn2.png";

// import registernormal3 from "../assets/2024/btn3.png";
import calendar from "../assets/calendar/calendar.png";
import { GiClick } from "react-icons/gi";
import Swal from "sweetalert2";
import packkagee from "../../package.json";
import { FaRegHandPointer } from "react-icons/fa";
import { MdFiberNew } from "react-icons/md";
import { admission } from "./ADMISSION";
import { mua } from "./MUA";

// 2026
import rob1 from "../assets/2026/normall/rob1.png";
import rob2 from "../assets/2026/normall/rob2.png";
import rob3 from "../assets/2026/normall/rob3.png";
import rob4 from "../assets/2026/normall/rob4.png";
import nrob1 from "../assets/2026/normall/nrob1.png";
import nrob2 from "../assets/2026/normall/nrob2.png";
import wrob1 from "../assets/2026/weekend/wrob1.png";
import wrob2 from "../assets/2026/weekend/wrob2.png";

export default class Register extends Component {


  constructor(props) {
    super(props);
    this.state = {
      robId: "",
      nation: "",
      nation_name: "",
      citizent: "",
      checked: false,
      screenWidth: 0,
      screenWidthcard: 0,
      countnews: 0,
      open: 0,

      array_Nation: [],
      array_robId: [],
      news: [],
      databuttonnormall: [
        {
          src: rob1,
          name: "robId",
          // id: "173",
          id: null,
          style: { opacity: "0.3", cursor: "pointer", maxWidth: "100%", height: "auto" },
          onClick: true,
        },
        {
          src: rob2,
          name: "robId",
          id: "176",
          style: { opacity: "1", cursor: "pointer", maxWidth: "100%", height: "auto" },
          onClick: true,
        },
        {
          src: rob3,
          name: "robId",
          id: null,
          style: { opacity: "0.3", cursor: "pointer", maxWidth: "100%", height: "auto" },
          onClick: true,
        },
        {
          src: rob4,
          name: "robId",
          id: null,
          style: { opacity: "0.3", cursor: "pointer", maxWidth: "100%", height: "auto" },
          onClick: true,
        },
        {
          src: nrob1,
          name: "robId",
          // id: '185',
          id: null,
          style: { opacity: "0.3", cursor: "pointer", maxWidth: "100%", height: "auto" },
          onClick: true,
        },
        {
          src: nrob2,
          name: "robId",
          id: null,
          style: { opacity: "0.3", cursor: "pointer", maxWidth: "100%", height: "auto" },
          onClick: true,
        },
      ], /// 2026
      dataweekend: [
        {
          src: wrob1,
          name: "robId",
          id: '187',
          style: { opacity: "1", cursor: "pointer", maxWidth: "100%", height: "auto" },
          onClick: true,
        },
        {
          src: wrob2,
          name: "robId",
          id: '188',
          style: { opacity: "0.3", cursor: "pointer", maxWidth: "100%", height: "auto" },
          onClick: false,
        },
      ],
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleRobChange = this.handleRobChange.bind(this);
    this.handleNationChange = this.handleNationChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.chkdate = this.chkdate.bind(this);
  }

  componentDidMount() {
    // ประเภทนักศึกษา
    // "1" ระดับปริญญาตรี ปกติ
    // "2" ระดับปริญญาตรี กศ.บป.
    // "3" ระดับปริญญาโท
    // "4" ระดับปริญญาเอก
    // "5" ระดับ ป.วิชาชีพครู
    const d = new Date().getDate();
    const stop = 28;
    if (d > stop) {
      this.setState({ open: 1 });
      // console.log(d);
      console.log("เปิด");
    } else {
      this.setState({ open: 0 });
      console.log("ปิด");
    }
    localStorage.clear();
    if (this.props.match.params.param === "0") {
      localStorage.setItem("robId", "141");
    }
    if (window.screen.width < 1600) {
      this.setState({ screenWidthcard: "100%" });
    } else {
      this.setState({ screenWidthcard: window.screen.width * 0.5 });
    }
    if (window.screen.width < 1500) {
      this.setState({ screenWidth: 240 });
    } else {
      this.setState({ screenWidth: window.screen.width * 0.15 });
    }

    // axios.get("https://git.kpru.ac.th/admission2017/administrator_new/show/"+ this.props.match.params.param).then((res) => {
    axios
      .get(
        "https://admission.kpru.ac.th/admission2017/administrator_new/shownewsBee/" +
        this.props.match.params.param
      )
      .then((res) => {
        this.setState({ countnews: res.data.length });
        this.setState({ news: res.data });
      });
    let id;
    if (this.props.match.params.param === "0") {
      id = "0";
    } else {
      id = this.props.match.params.param;
    }
    axios
      .get(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showrobregister/" +
        // this.props.match.params.param
        id
      )
      .then((rob) => {
        console.log(id);
        var i = 0;
        var today = "";
        today = new Date().getFullYear();
        if (new Date().getMonth() + 1 < 10) {
          today = today + "-0" + (new Date().getMonth() + 1);
        } else {
          today = today + "-" + (new Date().getMonth() + 1);
        }
        if (new Date().getDate() < 10) {
          today = today + "-0" + new Date().getDate();
        } else {
          today = today + "-" + new Date().getDate();
        }
        while (i < rob.data.data.data.length) {
          const startdate = new Date(rob.data.data.data[i]["ROB_OPEN"]).toLocaleDateString(
            "th-TH",
            {
              year: "numeric",
              month: "long",
              day: "numeric",
            }
          );
          const stopdate = new Date(rob.data.data.data[i]["ROB_CLOSE"]).toLocaleDateString(
            "th-TH",
            {
              year: "numeric",
              month: "long",
              day: "numeric",
            }
          );
          rob.data.data.data[i]["startdate"] = startdate;
          rob.data.data.data[i]["stopdate"] = stopdate;
          if (today === rob.data.data.data[i]["ROB_CLOSE"]) {
            rob.data.data.data[i]["checkdate"] = true;
          }
          if (
            rob.data.data.data[i]["ROB_ID"] === "90" ||
            rob.data.data.data[i]["ROB_ID"] === "91" ||
            rob.data.data.data[i]["ROB_ID"] === "94"
          ) {
            rob.data.data.data[i]["checkdate"] = false;
          }
          i++;
        }
        this.setState({ array_robId: rob.data.data.data });
        console.log(rob.data.data.data);
      });
    this.setState({
      array_Nation: [
        {
          value: "XX,ไม่มีสัญชาติ",
          label: "ไม่มีสัญชาติ",
          labelEN: "NO Nationality",
        },
        { value: "TH,ไทย", label: "ไทย", labelEN: "Thai" },
        { value: "CN,จีน", label: "จีน", labelEN: "China" },
        { value: "LA,ลาว", label: "ลาว", labelEN: "Lao" },
        { value: "MY,มาเลเซีย", label: "มาเลเซีย", labelEN: "Malasia" },
        { value: "MM,พม่า", label: "พม่า", labelEN: "Myanmar" },
        { value: "KH,กัมพูชา", label: "กัมพูชา", labelEN: "Cambodian" },
        { value: "ZZ,", label: "อื่นๆ", labelEN: "Other" },
      ],
    });
  }

  handleClick(event) {
    event.preventDefault();
    this.setState({ [event.target.name]: event.target.id });
  }

  handleRobChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleNationChange(event) {
    event.preventDefault();
    var splitnation = event.target.value.split(",");
    this.setState({ [event.target.name]: splitnation[0] });
    this.setState({ nation_name: splitnation[1] });
  }

  handleChange(event) {
    event.preventDefault();
    this.setState({ [event.target.name]: event.target.value });
  }

  handleCheck(event) {
    this.setState({ [event.target.name]: event.target.checked });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.nation === "TH") {
      if (this.state.citizent.length === 13) {
        axios
          .get(
            admission +
            "/dashboard/checkCitizent/" +
            // "https://git.kpru.ac.th/admission2017/dashboard/checkCitizent/" +
            this.state.citizent
          )
          .then((res) => {
            if (res.data === 1) {
              localStorage.setItem("citizent", this.state.citizent);
              localStorage.setItem("typestudent", this.props.match.params.param);
              localStorage.setItem("nation", this.state.nation);
              localStorage.setItem("nation_name", this.state.nation_name);
              let headers = new Headers({
                "Content-Type": "application/x-www-form-urlencoded",
              });
              axios
                .post(
                  mua + "/admissionnew2022/showcheckrobregister/",
                  {
                    robId: this.state.robId,
                    nation: this.state.nation,
                    nation_name: this.state.nation_name,
                    citizent: this.state.citizent,
                  },
                  { headers: headers }
                )
                .then((response) => {
                  if (this.props.match.params.param === "5") {
                    localStorage.setItem("token", response.data.data.auth);
                    localStorage.setItem("robId", this.state.robId);
                    if (response.data.data.data.length !== 0) {
                      if (response.data.data.data[0].status_register !== 0) {
                        axios
                          .get(
                            "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = "/" + packkagee.name + "/Dataregister";
                            } else {
                              window.location.href =
                                "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(
                                  "https://admission.kpru.ac.th/" + packkagee.name + "/Dataregister"
                                );
                            }
                          });
                      } else {
                        axios
                          .get(
                            "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = "/" + packkagee.name + "/Checkvutregister";
                            } else {
                              window.location.href =
                                "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(
                                  "https://admission.kpru.ac.th/" +
                                  packkagee.name +
                                  "/Checkvutregister"
                                );
                            }
                          });
                      }
                    } else {
                      axios
                        .get(
                          "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                          this.state.citizent +
                          "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                        )
                        .then((checkdata) => {
                          if (checkdata.data.length !== 0) {
                            window.location.href = "/" + packkagee.name + "/Checkvutregister";
                          } else {
                            window.location.href =
                              "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                              btoa(this.state.citizent) +
                              "&status=" +
                              btoa(3) +
                              "&url=" +
                              btoa(
                                "https://admission.kpru.ac.th/" +
                                packkagee.name +
                                "/Checkvutregister"
                              );
                          }
                        });
                    }
                  } else {
                    if (response.data.data.data.length !== 0) {
                      localStorage.setItem("token", response.data.data.auth);
                      localStorage.setItem("robId", this.state.robId);
                      const headers = {
                        "Content-Type": "application/json",
                        Authorization: `Basic ${response.data.data.auth}`,
                      };
                      axios
                        .get(
                          "https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showcheckvut",
                          { headers }
                        )
                        .then((checkvut) => {
                          if (checkvut.data.data.data.length !== 0) {
                            localStorage.setItem(
                              "level",
                              checkvut.data.data.data[0]["LEVEL_EDU_ID"]
                            );
                            localStorage.setItem("plan", checkvut.data.data.data[0]["PLAN_ID"]);
                            localStorage.setItem(
                              "vga",
                              checkvut.data.data.data[0]["LEVEL_MEMBER_VGA"]
                            );
                          }
                          console.log(response);
                          if (response.data.data.data[0].status_register !== 0) {
                            window.location.href = "/" + packkagee.name + "/Dataregister";
                            axios
                              .get(
                                "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                                this.state.citizent +
                                "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                              )
                              .then((checkdata) => {
                                if (checkdata.data.length !== 0) {
                                  // window.location.href =
                                  //   "/" + packkagee.name + "/Dataregister";
                                } else {
                                  window.location.href =
                                    "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                    btoa(this.state.citizent) +
                                    "&status=" +
                                    btoa(3) +
                                    "&url=" +
                                    btoa(
                                      "https://admission.kpru.ac.th/" +
                                      packkagee.name +
                                      "/Dataregister"
                                    );
                                }
                              });
                          } else {
                            // window.location.href = "/"+packkagee.name+"/Checkvutregister";
                            axios
                              .get(
                                "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                                this.state.citizent +
                                "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                              )
                              .then((checkdata) => {
                                if (checkdata.data.length !== 0) {
                                  window.location.href = "/" + packkagee.name + "/Checkvutregister";
                                } else {
                                  window.location.href =
                                    "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                    btoa(this.state.citizent) +
                                    "&status=" +
                                    btoa(3) +
                                    "&url=" +
                                    btoa(
                                      "https://admission.kpru.ac.th/" +
                                      packkagee.name +
                                      "/Checkvutregister"
                                    );
                                }
                              });
                          }
                        });
                    } else {
                      localStorage.setItem("token", response.data.data.auth);
                      localStorage.setItem("robId", this.state.robId);
                      // window.location.href = "/"+packkagee.name+"/Checkvutregister";
                      axios
                        .get(
                          "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                          this.state.citizent +
                          "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                        )
                        .then((checkdata) => {
                          if (checkdata.data.length !== 0) {
                            window.location.href = "/" + packkagee.name + "/Checkvutregister";
                          } else {
                            window.location.href =
                              "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                              btoa(this.state.citizent) +
                              "&status=" +
                              btoa(3) +
                              "&url=" +
                              btoa(
                                "https://admission.kpru.ac.th/" +
                                packkagee.name +
                                "/Checkvutregister"
                              );
                          }
                        });
                    }
                  }
                });
            } else {
              Swal.fire("เลขบัตรประชาชนไม่ถูกต้อง", "กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง", "error");
            }
          });
      }
    } else {
      localStorage.setItem("citizent", this.state.citizent);
      localStorage.setItem("typestudent", this.props.match.params.param);
      localStorage.setItem("nation", this.state.nation);
      localStorage.setItem("nation_name", this.state.nation_name);
      let headers = new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      });
      axios
        .post(
          "https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showcheckrobregister/",
          {
            robId: this.state.robId,
            nation: this.state.nation,
            nation_name: this.state.nation_name,
            citizent: this.state.citizent,
          },
          { headers: headers }
        )
        .then((response) => {
          if (this.props.match.params.param === "5") {
            localStorage.setItem("token", response.data.data.auth);
            localStorage.setItem("robId", this.state.robId);
            if (response.data.data.data.length !== 0) {
              if (response.data.data.data[0].status_register !== 0) {
                axios
                  .get(
                    "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                    this.state.citizent +
                    "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                  )
                  .then((checkdata) => {
                    if (checkdata.data.length !== 0) {
                      window.location.href = "/" + packkagee.name + "/Dataregister";
                    } else {
                      window.location.href =
                        "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                        btoa(this.state.citizent) +
                        "&status=" +
                        btoa(3) +
                        "&url=" +
                        btoa("https://admission.kpru.ac.th/" + packkagee.name + "/Dataregister");
                    }
                  });
              } else {
                axios
                  .get(
                    "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                    this.state.citizent +
                    "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                  )
                  .then((checkdata) => {
                    if (checkdata.data.length !== 0) {
                      window.location.href = "/" + packkagee.name + "/Formprofile";
                    } else {
                      window.location.href =
                        "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                        btoa(this.state.citizent) +
                        "&status=" +
                        btoa(3) +
                        "&url=" +
                        btoa(
                          "https://admission.kpru.ac.th/" + packkagee.name + "/Checkvutregister"
                        );
                    }
                  });
              }
            } else {
              axios
                .get(
                  "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                  this.state.citizent +
                  "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                )
                .then((checkdata) => {
                  if (checkdata.data.length !== 0) {
                    window.location.href = "/" + packkagee.name + "/Checkvutregister";
                  } else {
                    window.location.href =
                      "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                      btoa(this.state.citizent) +
                      "&status=" +
                      btoa(3) +
                      "&url=" +
                      btoa("https://admission.kpru.ac.th/" + packkagee.name + "/Checkvutregister");
                  }
                });
            }
          } else {
            if (response.data.data.data.length !== 0) {
              localStorage.setItem("token", response.data.data.auth);
              localStorage.setItem("robId", this.state.robId);
              const headers = {
                "Content-Type": "application/json",
                Authorization: `Basic ${response.data.data.auth}`,
              };
              axios
                .get("https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showcheckvut", {
                  headers,
                })
                .then((checkvut) => {
                  if (checkvut.data.data.data.length !== 0) {
                    localStorage.setItem("level", checkvut.data.data.data[0]["LEVEL_EDU_ID"]);
                    localStorage.setItem("plan", checkvut.data.data.data[0]["PLAN_ID"]);
                    localStorage.setItem("vga", checkvut.data.data.data[0]["LEVEL_MEMBER_VGA"]);
                  }
                  if (response.data.data.data[0].status_register !== 0) {
                    window.location.href = "/" + packkagee.name + "/Dataregister";
                    axios
                      .get(
                        "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        this.state.citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          window.location.href = "/" + packkagee.name + "/Dataregister";
                        } else {
                          window.location.href =
                            "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                            btoa(this.state.citizent) +
                            "&status=" +
                            btoa(3) +
                            "&url=" +
                            btoa(
                              "https://admission.kpru.ac.th/" + packkagee.name + "/Dataregister"
                            );
                        }
                      });
                  } else {
                    // window.location.href = "/"+packkagee.name+"/Checkvutregister";
                    axios
                      .get(
                        "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        this.state.citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          window.location.href = "/" + packkagee.name + "/Checkvutregister";
                        } else {
                          window.location.href =
                            "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                            btoa(this.state.citizent) +
                            "&status=" +
                            btoa(3) +
                            "&url=" +
                            btoa(
                              "https://admission.kpru.ac.th/" + packkagee.name + "/Checkvutregister"
                            );
                        }
                      });
                  }
                });
            } else {
              localStorage.setItem("token", response.data.data.auth);
              localStorage.setItem("robId", this.state.robId);
              // window.location.href = "/"+packkagee.name+"/Checkvutregister";
              axios
                .get(
                  "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                  this.state.citizent +
                  "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                )
                .then((checkdata) => {
                  if (checkdata.data.length !== 0) {
                    window.location.href = "/" + packkagee.name + "/Checkvutregister";
                  } else {
                    window.location.href =
                      "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                      btoa(this.state.citizent) +
                      "&status=" +
                      btoa(3) +
                      "&url=" +
                      btoa("https://admission.kpru.ac.th/" + packkagee.name + "/Checkvutregister");
                  }
                });
            }
          }
        });
    }
  }
  chkdate(robclose) {
    const closedate = new Date(robclose + " 23:59");
    const today = new Date();
    const result = closedate >= today ? "yes" : "no";
    console.log(result);
    console.log(closedate);
    console.log(today);
    return result;
  }

  render() {
    return (
      <>
        <MetaTags>
          <title>รอบการเปิดรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="รอบการเปิดรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta property="og:title" content="รอบการเปิดรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          {this.props.match.params.param === "1" ? (
            <>
              <h4>สมัครเรียนปริญญาตรีภาคปกติ (จันทร์-ศุกร์) มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
            </>
          ) : (
            <>
              {this.props.match.params.param === "2" ? (
                <>
                  <h4>สมัครเรียนปริญญาตรีภาคกศ.บป. (เสาร์-อาทิตย์) มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
                </>
              ) : (
                <>
                  {this.props.match.params.param === "3" ? (
                    <>
                      <h4>สมัครเรียนระดับบัณฑิตวิทยาลัย มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
                    </>
                  ) : (
                    <>
                      {this.props.match.params.param === "4" ? (
                        <>
                          <h4>สมัครเรียนระดับบัณฑิตวิทยาลัย มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
                        </>
                      ) : (
                        <>
                          {this.props.match.params.param === "5" ? (
                            <>
                              <h4>
                                สมัครเรียนประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู
                                มหาวิทยาลัยราชภัฏกำแพงเพชร
                              </h4>
                            </>
                          ) : (
                            <>
                              {" "}
                              {this.props.match.params.param === "0" ? (
                                <>
                                  <h4>
                                    สมัครเรียนประกาศนียบัตรผู้ช่วยพยาบาล มหาวิทยาลัยราชภัฏกำแพงเพชร
                                  </h4>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
          <MDBRow>
            <MDBCol lg="1" md="1" sm="1"></MDBCol>
            <MDBCol lg="10" md="10" sm="10">
              <div>
                <MDBCardBody>
                  <MDBCardText>
                    <form onSubmit={this.handleSubmit}>
                      {this.state.robId > 0 ? (
                        <>
                          <div className="form-outline">
                            <label className="form-label" for="nation">
                              สัญชาติ (Nationality)
                            </label>
                            <select
                              className="form-control"
                              id="nation"
                              name="nation"
                              onChange={this.handleNationChange}
                              required
                            >
                              <option value="" hidden>
                                ---ระบุสัญชาติ (Nationality)---
                              </option>
                              {this.state.array_Nation.map((data) => {
                                return (
                                  <option value={data.value}>
                                    {data.label} ({data.labelEN})
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          {this.state.nation !== "" ? (
                            <>
                              {this.state.nation === "TH" ? (
                                <>
                                  <div className="form-outline">
                                    <label className="form-label" for="citizent">
                                      รหัสเลขบัตรประชาชน
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="citizent"
                                      name="citizent"
                                      placeholder="รหัสเลขบัตรประชาชน"
                                      maxLength="13"
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  {this.state.nation === "ZZ" ? (
                                    <>
                                      <div className="form-outline">
                                        <label className="form-label" for="nation_name">
                                          ชื่อสัญชาติ
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="nation_name"
                                          name="nation_name"
                                          placeholder="กรุณาระบุสัญชาติ"
                                          value={this.state.nation_name}
                                          onChange={this.handleChange}
                                          required
                                        />
                                      </div>

                                      <div className="form-outline">
                                        <label className="form-label" for="citizent">
                                          รหัสเลขบัตรประชาชน/เลขบัตร Passport /
                                          รหัสบัตรที่ใช้ยืนยันตัวตน
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="citizent"
                                          name="citizent"
                                          placeholder="รหัสเลขบัตรประชาชน/เลขบัตร Passport"
                                          onChange={this.handleChange}
                                          required
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="form-outline">
                                        <label className="form-label" for="citizent">
                                          รหัสเลขบัตรประชาชน/เลขบัตร Passport
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="citizent"
                                          name="citizent"
                                          placeholder="รหัสเลขบัตรประชาชน/เลขบัตร Passport"
                                          onChange={this.handleChange}
                                          required
                                        />
                                      </div>
                                    </>
                                  )}
                                </>
                              )}
                              <div className="form-outline">
                                <input
                                  type="checkbox"
                                  id="vehicle1"
                                  name="checked"
                                  onChange={this.handleCheck}
                                />
                                <label for="vehicle1">
                                  &nbsp;ข้าพเจ้ายืนยันว่าได้ศึกษาข้อมูลหลักสูตร สาขาวิชา
                                  และคณะที่เปิดรับสมัคร จากเอกสารข้างต้นเรียบร้อยแล้ว
                                </label>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                          <br />
                          <div className="form-outline">
                            {this.state.nation === "TH" ? (
                              <>
                                {this.state.nation_name !== "" &&
                                  this.state.citizent.length === 13 &&
                                  this.state.checked ? (
                                  <>
                                    <button type="submit" className="btn btn-primary">
                                      เริ่มกรอกข้อมูลสมัคร
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button type="submit" className="btn btn-primary" disabled>
                                      เริ่มกรอกข้อมูลสมัคร
                                    </button>
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {this.state.nation_name !== "" &&
                                  this.state.citizent !== "" &&
                                  this.state.checked ? (
                                  <>
                                    <button type="submit" className="btn btn-primary">
                                      เริ่มกรอกข้อมูลสมัคร
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button type="submit" className="btn btn-primary" disabled>
                                      เริ่มกรอกข้อมูลสมัคร
                                    </button>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          {/* <img
                                    src={registernormal1}
                                    width={this.state.screenWidth}
                                    name="robId"
                                    id="152"
                                    style={{ opacity: "0.3", cursor: "pointer" }}
                                    // onClick={this.handleClick}
                                  /> */}
                          <div className="glass2">
                            {this.props.match.params.param === "1" ? (
                              <>
                                {/* ใช้ 2026 */}
                                <div
                                  className="container-fluid d-flex   flex-wrap   align-items-center  "
                                  style={{
                                    justifyContent: "flex-start",
                                    margin: 0,
                                  }}
                                >
                                  {this.state.databuttonnormall.map((i, key) => {
                                    return (
                                      <div
                                        key={key}
                                        style={{ margin: 0 }}
                                        className="col-12 col-xl-3 col-lg-6 d-flex justify-content-center"
                                      >
                                        <img
                                          width={this.state.screenWidth}
                                          // className="bg-danger"
                                          alt=""
                                          src={i.src}
                                          style={i.style}
                                          id={i.id}
                                          name={i.name}
                                          onClick={i.onClick ? this.handleClick : <></>}
                                        />
                                      </div>
                                    );
                                  })}
                                </div>

                                {/* /////////////////////// */}
                                {/* ไม่ใช้แล้ว */}
                                <div
                                  className="d-none container-fluid  p-0   flex-wrap   align-items-center"
                                  style={{
                                    gap: "10px",
                                    justifyContent: "flex-start",
                                    display: "none",
                                  }}
                                >
                                  {/* <img src={registernormal1} width={this.state.screenWidth} name="robId" id="108" onClick={this.handleClick} /> */}

                                  <img
                                    src={registernormal2}
                                    width={this.state.screenWidth}
                                    name="robId"
                                    id="156"
                                    style={{ opacity: "0.3", cursor: "pointer" }}
                                  />
                                  <img
                                    src={registernurse}
                                    width={this.state.screenWidth}
                                    name="robId"
                                    id="159"
                                    style={{ opacity: "0.3", cursor: "pointer" }}
                                  />
                                  <img
                                    src={registernormal3}
                                    width={this.state.screenWidth}
                                    name="robId"
                                    id="161"
                                    style={{ opacity: "0.3", cursor: "pointer" }}
                                  // onClick={this.handleClick}
                                  // style={{ opacity:this.state.open === 1? "0.3":"1", cursor: "pointer" }}
                                  // onClick={this.state.open === 0&& this.handleClick}
                                  />
                                  <img
                                    src={registernormal4}
                                    width={this.state.screenWidth}
                                    name="robId"
                                    id="166"
                                    style={{
                                      opacity: "0.3",
                                      cursor: "pointer",
                                    }}
                                  // onClick={this.handleClick}
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="form-outline">
                                  <label className="form-label" for="robId">
                                    รอบที่ต้องการสมัครเรียน
                                  </label>
                                  {this.state.array_robId.length !== 0 ? (
                                    <>
                                      {this.props.match.params.param !== "2" ? (
                                        <>
                                          {this.state.array_robId.map((data) => {
                                            return (
                                              <li>
                                                {this.props.match.params.param === "0" &&
                                                  data.QUOTA_ID === "38" && (
                                                    <>
                                                      {data.QUOTA_NAME} {data.ROB_NAME} เปิดตั้งแต่{" "}
                                                      {data.startdate} ถึง {data.stopdate} &nbsp;
                                                      <a
                                                        style={{ color: "gray" }}
                                                        name="robId"
                                                        id={data.ROB_ID}
                                                      // onClick={this.handleClick}
                                                      >
                                                        คลิกที่นี่ *
                                                      </a>
                                                    </>
                                                  )}
                                                {this.props.match.params.param === "5" &&
                                                  data.QUOTA_ID !== "38" && (
                                                    <>
                                                      {data.QUOTA_NAME} {data.ROB_NAME} เปิดตั้งแต่{" "}
                                                      {data.startdate} ถึง {data.stopdate} &nbsp;
                                                      <a
                                                        style={{ color: "gray" }}
                                                        // ROB_STATUS
                                                        // style={{ color:data.ROB_STATUS === 'T'? "blue":"gray" }}
                                                        name="robId"
                                                        id={data.ROB_ID}
                                                      // onClick={data.ROB_STATUS ==="T"? this.handleClick:""}
                                                      >
                                                        คลิกที่นี่
                                                      </a>
                                                    </>
                                                  )}
                                              </li>
                                            );
                                          })}
                                        </>
                                      ) : (
                                        <>
                                          {/* 2026 */}
                                          <div
                                            className="container-fluid d-flex   flex-wrap   align-items-center "
                                            style={{
                                              justifyContent: "flex-start",
                                              margin: 0,
                                            }}
                                          >
                                            {this.state.dataweekend.map((i, key) => {
                                              return (
                                                <div
                                                  key={key}
                                                  style={{ margin: 0 }}
                                                  className="col-12 col-xl-3 col-lg-6 d-flex justify-content-center"
                                                >
                                                  <img
                                                    width={this.state.screenWidth}
                                                    alt=""
                                                    src={i.src}
                                                    style={i.style}
                                                    id={i.id}
                                                    name={i.name}
                                                    onClick={i.onClick ? this.handleClick : <></>}
                                                  />
                                                </div>
                                              );
                                            })}
                                          </div>

                                          {/* <Pane>
                                            <img
                                              src={registernormalk1}
                                              width={this.state.screenWidth}
                                              name="robId"
                                              id="154"
                                              alt=""
                                              style={{ opacity: "0.3", cursor: "pointer" }}
                                              onClick={this.handleClick}
                                            />
                                            <img
                                              src={registernormalk2}
                                              width={this.state.screenWidth}
                                              name="robId"
                                              alt=""
                                              id="168"
                                              style={{ opacity: "0.3", cursor: "pointer" }}
                                              onClick={this.state.open === 0 && this.handleClick}
                                            />
                                          </Pane> */}
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <br />
                                      <li className="text-danger">ยังไม่มีรอบเปิดสมัครเรียน</li>
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </form>
                    {this.state.countnews !== 0 ? (
                      <div className="glass3 mt-2 px-2">
                        <MDBTable striped>
                          <MDBTableHead>
                            <tr>
                              <th className="btn btn-teal">
                                <MDBIcon icon="bullhorn" /> ข่าวประชาสัมพันธ์{" "}
                              </th>
                            </tr>
                          </MDBTableHead>
                          <MDBTableBody>
                            {this.state.news.slice(0, 3).map((data, index) => {
                              return (
                                <tr>
                                  <>
                                    <td>
                                      <li>
                                        {index === 0 ? (
                                          <>
                                            <blink>
                                              <MdFiberNew color="red" size={20} />
                                            </blink>
                                          </>
                                        ) : (
                                          <></>
                                        )}
                                        {data.NEWS_TITEL}{" "}
                                        <span className="text-primary">
                                          ( ข้อมูล ณ วันที่ {data.datetime})
                                        </span>{" "}
                                        <a
                                          className="text-success"
                                          href={data.NEWS_FILE}
                                          // ref={"noreferrer"}
                                          target="_blank"
                                        >
                                          <u>
                                            <Button appearance="m" color="orange">
                                              อ่านต่อ
                                            </Button>
                                          </u>
                                        </a>
                                      </li>
                                    </td>
                                  </>
                                </tr>
                              );
                            })}
                            <tr>
                              <td className="text-right text-primary">
                                <a
                                  className="btn btn-primary"
                                  href={
                                    "/" + packkagee.name + "/News/" + this.props.match.params.param
                                  }
                                >
                                  <u>ดูเพิ่มเติม</u>
                                </a>
                              </td>
                            </tr>
                          </MDBTableBody>
                        </MDBTable>
                      </div>
                    ) : (
                      <></>
                    )}
                    {this.props.match.params.param === "1" ? (
                      <>
                        <div className="text-center">
                          {/* <img className="m-2" src={calendar} width="100%" /> */}
                          {/* <img className="m-2" src={calendar} width={this.state.screenWidthcard} /> */}
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </MDBCardText>
                </MDBCardBody>
              </div>
            </MDBCol>
            <MDBCol lg="1" md="1" sm="1"></MDBCol>
          </MDBRow>
        </MDBContainer>
        <br />
      </>
    );
  }
}
